// blog.js
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import "./blog.css";

const allPosts = [
  {
    id: 1,
    title: "How Financial Planning Helps You Win 2025",
    excerpt: "Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living. ",
    date: "2025-08-20",
  },
  {
    id: 2,
    title: "Why Budgeting Matters More Than Ever",
    excerpt: "Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living.",
    date: "2025-08-14",
  },
  {
    id: 3,
    title: "The Truth About Credit Scores in India",
    excerpt: "Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living.",
    date: "2025-08-05",
  },
  {
    id: 4,
    title: "Loan Approval Myths Busted",
    excerpt: "Discover why planning ahead gives you a strong financial edge.lorem ispsum dolor sit amet. Budgeting isn't just for saving—it's for smart living.",
    date: "2025-07-22",
  },
];

const Blog = () => {
  const [visibleCount, setVisibleCount] = useState(3);

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const handleViewMore = () => {
    setVisibleCount((prev) => Math.min(prev + 2, allPosts.length));
  };

  const visiblePosts = allPosts
    .slice()
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, visibleCount);

  return (
    <section className="blog-section py-5">
      <div className="container">
        <h2 className="section-title text-center mb-5" data-aos="fade-up">
          Latest <span>Blog Posts</span>
        </h2>
        <div className="row">
          {visiblePosts.map((post) => (
            <div className="col-md-4 mb-4" key={post.id}>
              <div className="modern-blog-card" data-aos="fade-up">
                <div className="blog-img-wrap">
                  <img
                    src={`https://picsum.photos/400/250?random=${post.id}`}
                    alt={post.title}
                    className="img-fluid"
                  />
                </div>
                <div className="blog-info">
                  <p className="blog-date">
                    {new Date(post.date).toLocaleDateString()}
                  </p>
                  <h5 className="blog-title">{post.title}</h5>
                  <p className="blog-excerpt">{post.excerpt}</p>
                  <Link to={`/blog-details/${post.id}`} className="read-more-link">
                    Read More →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {visibleCount < allPosts.length && (
          <div className="text-center mt-4" data-aos="fade-up">
            <button
              className="btn btn-primary view-more-btn"
              onClick={handleViewMore}
            >
              View More Blogs
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Blog;
